import React from "react";
import { RIGHT_ALIGNMENT } from "@elastic/eui/lib/services/alignment";
import { Link } from "react-router-dom";
import { EuiIcon, EuiToolTip } from "@elastic/eui";
import configureStore from "../../../app/store";
import TripPointsCell from "../components/Table/TripPointsCell";
import DriverCell from "../components/Table/DriverCell";
import TruckCell from "../components/Table/TruckCell";
import SupplierCell from "../components/Table/SupplierCell";
import TripBadge from "../components/shared/TripBadge";
import {
    dateToDay,
    dateToFormattedFullDate,
    dateToFormattedTime,
} from "../../../utils/dateAndTime";
import OrganizationCell from "../components/Table/OrganizationCell";
import entityLinkOptions from "./entityLinkOptions";
import { clearCommentStates } from "../../shared/Comments/commentSlice";
import MapIcon from "../../../assets/icons/mapIcon";

// EuiTable format

// const dispatch = useDispatch();
const store = configureStore;
const clearCommentStore = () => {
    store.dispatch(clearCommentStates());
};

const columns = [
    {
        id: "id",
        label: "ID",
        width: 100,
        render: (id) => (
            <Link
                to={`/database/trips/${id}`}
                onClick={clearCommentStore()}
            >
                <b>#{id}</b>
            </Link>
        ),
        isSortable: true,
    },
    {
        id: "source",
        label: "App",
        width: 70,
        render: (source) => {
            const isSystem = source === "system";
            return (
                <EuiToolTip
                    position="top"
                    content={
                        isSystem ? "Trip operated through driver app" : "Trip entered manually"
                    }
                >
                    <span style={{ opacity: isSystem ? 1 : 0.2 }}>
                        <EuiIcon
                            color={isSystem ? "success" : "subdued"}
                            type="checkInCircleFilled"
                            size="m"
                        />
                    </span>
                </EuiToolTip>
            );
        },
        isSortable: true,
    },
    {
        id: "geofence",
        label: "Geofencing",
        width: 120,
        render: (item) => (
            <div style={{ wordBreak: "keep-all", lineHeight: "18px" }}>
                <MapIcon fill={item ? "#0436DA" : "#D1D5DB"} />
            </div>
        ),
        isSortable: true,
    },
    {
        id: "collectingNumberOffloadedUnits",
        label: "collectingNumberOffloadedUnits",
        width: 120,
        render: (item) => (
            <div style={{ wordBreak: "keep-all", lineHeight: "18px" }}>{item ? "Yes" : "No"}</div>
        ),
        isSortable: false,
    },
    {
        id: "pickupTime",
        label: "Pickup Date",
        width: 120,
        render: (field, pickupDate) => (
            <div style={{ wordBreak: "keep-all", lineHeight: "18px" }}>
                {pickupDate ? (
                    <>
                        <small>{dateToDay(pickupDate)}</small>
                        <br />
                        <b>{dateToFormattedFullDate(pickupDate)}</b>
                        <br />
                        <small>{dateToFormattedTime(pickupDate)}</small>{" "}
                    </>
                ) : (
                    <b>N/A</b>
                )}
            </div>
        ),
        isSortable: true,
    },
    {
        id: "organizationId",
        label: "Client",
        render: (organizationId, organization) => (
            <OrganizationCell
                organization={organization}
                entityLinkOptions={entityLinkOptions.organization}
            />
        ),
        isSortable: true,
    },
    {
        id: "tripPoints",
        label: "Route",
        render: (tripPointsId, tripPoints, trip, fetchTrips, tripType) => (
            <TripPointsCell
                tripPoints={tripPoints}
                trip={trip}
                fetchTrips={fetchTrips}
                tripType={tripType}
            />
        ),
        width: "30%",
    },
    {
        id: "driverId",
        label: "Driver",
        render: (driverId, driver) => (
            <DriverCell
                driver={driver}
                entityLinkOptions={entityLinkOptions.driver}
            />
        ),
        isSortable: true,
        width: 140,
    },
    {
        id: "supplierId",
        label: "Supplier",
        render: (supplierId, supplier) => (
            <SupplierCell
                supplier={supplier}
                entityLinkOptions={entityLinkOptions.supplier}
            />
        ),
        isSortable: true,
        width: 140,
    },
    {
        id: "truckId",
        label: "Truck",
        render: (truckId, truck) => (
            <TruckCell
                truck={truck}
                entityLinkOptions={entityLinkOptions.truck}
            />
        ),
        isSortable: true,
        width: 140,
    },
    {
        id: "status",
        label: "Status",
        render: (item) => <TripBadge status={item} />,
        isSortable: true,
        width: 150,
    },
    {
        id: "platformType",
        label: "Platform",
        width: "15%",
        render: (item) => <div>{item && <span>{item}</span>}</div>,
        isSortable: true,
    },
    {
        id: "tripActions",
        label: "Actions",
        alignment: RIGHT_ALIGNMENT,
        isActionsPopover: true,
        width: 100,
    },
];

export default columns;
